import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { MarkedItem } from '../interfaces/marked-item.model';

interface Ergebnis {
  berechnungId: string;
  kombinationId: string;
  [key: string]: unknown;
}

@Pipe({
  name: 'toMarkedItem',
  standalone: true,
})
export class ToMarkedItemPipe implements PipeTransform {
  transform(value: Ergebnis): MarkedItem {
    return {
      kombinationId: value.kombinationId,
      berechnungId: value.berechnungId,
    };
  }
}
